<template>
    <div class="col-lg-12 px-0">
        <card class="bg-none shadow-none mb-0">
            <div slot="header" class="card-title">
                <h2 class="mb-0">Delivery Requests</h2>
                <small>Showing delivery requests within 1 year of today</small>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
                <div :class="$style.statusFilter">
                    <label>Filter on Status</label>
                    <el-select
                        v-model="deliveryStatusFilter"
                        class="select-primary"
                        placeholder="Filter delivery requests"
                    >
                        <el-option
                            v-for="status in deliveryStatuses"
                            :key="status"
                            class="select-primary"
                            :label="status"
                            :value="status"
                        />
                    </el-select>
                </div>
            </div>
            <table-search-and-pagination
                hide-per-page
                :table-data="deliveries"
                @dataUpdated="queriedData = $event"
            >
                <template>
                    <delivery-requests-table
                        v-if="deliveries.length > 0"
                        :scheduled-deliveries="queriedData"
                        :exclude-columns="excludedColumns"
                        @rowClicked="$emit('deliveryRequestRowClicked', $event)"
                    />
                    <h4 v-else>
                        You have no delivery requests with a status of
                        <strong>{{ deliveryStatusFilter }}</strong>
                    </h4>
                </template>
            </table-search-and-pagination>
        </card>
        <delivery-request-detail
            v-if="showDeliveryRequestSummary"
            :delivery="selectedDeliveryRequest"
            :show="showDeliveryRequestSummary"
            @update:show="$emit('update:showDeliveryRequestSummary', $event)"
        />
    </div>
</template>

<script>
import DeliveryRequestDetail from "src/modules/DeliveryRequest/DeliveryRequestDetail";
import DeliveryRequestsTable from "src/modules/DeliveryRequest/DeliveryRequests/_components/DeliveryRequestsTable";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";

export default {
    name: "DeliveryRequests",
    components: {
        DeliveryRequestDetail,
        DeliveryRequestsTable,
        TableSearchAndPagination,
    },
    props: {
        excludedColumns: {
            type: Array,
            default: () => [],
        },
        deliveries: {
            type: Array,
            default: () => [],
        },
        showDeliveryRequestSummary: {
            type: Boolean,
            required: true,
        },
        selectedDeliveryRequest: {
            type: Object,
            default: () => {},
        },
        defaultStatusFilter: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loaded: false,
            queriedData: [],
            deliveryStatusFilter: "Default",
            deliveryStatuses: [
                "All",
                "Default",
                "Submitted",
                "Pending",
                "Scheduled",
                "OnHold",
                "Cancelled",
                "Delivered",
            ],
        };
    },
    computed: {
        isWillCall() {
            return this.selectedDeliveryRequest.willCall;
        },
    },
    watch: {
        deliveryStatusFilter(val) {
            if (!this.loaded) {
                return;
            }
            this.$emit("statusFilterUpdated", val);
        },
    },
    created() {
        this.deliveryStatusFilter = this.defaultStatusFilter;
        // avoid triggering the watch function for the first load
        this.$nextTick(() => {
            this.loaded = true;
        });
    },
};
</script>

<style module>
.statusFilter {
    display: flex;
    flex-direction: column;
}
.shadow-none {
    box-shadow: none;
}
.bg-none {
    background: none;
}
</style>
